import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/** "May 27, 2026" */
export function formatDate(date: string | Date): string {
	return new Date(date).toLocaleDateString('en-US', {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
	});
}

/** "2h ago", "3d ago", or falls back to formatDate */
export function timeAgo(date: string | Date): string {
	const now = Date.now();
	const then = new Date(date).getTime();
	const diff = Math.max(0, now - then);
	const minutes = Math.floor(diff / 60000);
	if (minutes < 1) return 'Just now';
	if (minutes < 60) return `${minutes}m ago`;
	const hours = Math.floor(minutes / 60);
	if (hours < 24) return `${hours}h ago`;
	const days = Math.floor(hours / 24);
	if (days < 7) return `${days}d ago`;
	return formatDate(date);
}

/** "May 2026" */
export function formatMonthYear(date: string | Date): string {
	return new Date(date).toLocaleDateString('en-US', {
		month: 'short',
		year: 'numeric',
	});
}

/**
 * Formats a projected-delivery window ("Jun 3 – Jun 18"). Collapses to a single
 * date when only one bound is present or both fall on the same day. Returns
 * `null` when neither bound is set (e.g. production time isn't known yet), so
 * callers can hide the field.
 */
export function formatArrivalWindow(
	earliest?: string | null,
	latest?: string | null
): string | null {
	const short = (date: string) =>
		new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
	if (earliest && latest) {
		const a = short(earliest);
		const b = short(latest);
		return a === b ? a : `${a} – ${b}`;
	}
	if (earliest) return short(earliest);
	if (latest) return short(latest);
	return null;
}
